<ion-header>
  <ion-toolbar>
    <ion-title>Obecné</ion-title>

    <ion-buttons slot="start">
      <ion-menu-button appMenuNotificationDot></ion-menu-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-segment [(ngModel)]="selectedTab">
    <ion-segment-button *ngFor="let tab of (visibleTabs$ | async)" [value]="tab.toString()">
      {{ tab === ConfigTabType.Obecne ? 'Obecné' : (tab == ConfigTabType.OA ? 'OA' : (tab == ConfigTabType.PS ? 'PS' : tab)) }}
    </ion-segment-button>
  </ion-segment>

  <form [formGroup]="form">
    <div *ngIf="selectedTab === ConfigTabType.Obecne">
      <fieldset>
        <legend>
          <ion-label>Seznam asistentů</ion-label>
        </legend>
        <div class="row">
          <div class="label">Volitelné sloupce</div>
          <div class="align-end">
            <app-column-select
              [formControlName]="configKeys.ASSISTANT_LIST_CUSTOM_COLUMNS"
              [value]="configuredCustomColumns.assistantList | async"
              [columns]="availableCustomColumns.assistantList"
              [allowEmpty]="false"
            ></app-column-select>
          </div>
        </div>
      </fieldset>
    </div>
    <div *ngIf="selectedTab === ConfigTabType.OA.toString()">
      <fieldset>
        <legend>
          <ion-label>Pracovní hodiny koordinátorů</ion-label>
        </legend>
        <ion-item>
          Pracovní hodiny koordinátorů (v pracovní dny)
          <ejs-timepicker
            slot="end"
            [formControlName]="configKeys.ORDINACNI_HODINY_START_NO_TZ"
            [value]="configs[configKeys.ORDINACNI_HODINY_START_NO_TZ]"
          >
          </ejs-timepicker>
          <span slot="end">-</span>
          <ejs-timepicker
            slot="end"
            [formControlName]="configKeys.ORDINACNI_HODINY_END_NO_TZ"
            [value]="configs[configKeys.ORDINACNI_HODINY_END_NO_TZ]"
          >
          </ejs-timepicker>
        </ion-item>
      </fieldset>
      <fieldset>
        <legend>
          <ion-label>Pozdě objednané asistence</ion-label>
        </legend>
        <ion-item>
          Počet hodin před začátkem týdne, ve kterém asistence probíhá
          <ion-input
            slot="end"
            type="number"
            [formControlName]="configKeys.ODKDY_JE_POZDE_OBJEDNANA_ASISTENCE_HODINY"
            [value]="configs[configKeys.ODKDY_JE_POZDE_OBJEDNANA_ASISTENCE_HODINY]"
          ></ion-input>
          <ejs-tooltip
            slot="end"
            id="tooltip"
            [content]="tooltipTexts[configKeys.ODKDY_JE_POZDE_OBJEDNANA_ASISTENCE_HODINY]"
          >
            <ion-icon name="help-circle"></ion-icon>
          </ejs-tooltip>
        </ion-item>
        <ion-item>
          Vztahuje se i na asistence založené koordinátory
          <ion-checkbox
            slot="end"
            [formControlName]="configKeys.POZDE_OBJEDNANA_JESTLI_SE_VZTAHUJE_NA_KOORDINATORY"
          ></ion-checkbox>
          <ejs-tooltip
            slot="end"
            id="tooltip2"
            [content]="tooltipTexts[configKeys.POZDE_OBJEDNANA_JESTLI_SE_VZTAHUJE_NA_KOORDINATORY]"
          >
            <ion-icon name="help-circle"></ion-icon>
          </ejs-tooltip>
        </ion-item>
      </fieldset>
      <fieldset>
        <legend>
          <ion-label>Pozdní zrušení (storno) asistence</ion-label>
        </legend>
        <ion-item>
          Asistence je pozdě zrušená, když se zruší kolik hodin před plánovaným začátkem
          <ion-input
            slot="end"
            type="number"
            [formControlName]="configKeys.ODKDY_JE_POZDE_ZRUSENA_JIZ_POTVRZENA_ASISTENCE_HODINY"
            [value]="configs[configKeys.ODKDY_JE_POZDE_ZRUSENA_JIZ_POTVRZENA_ASISTENCE_HODINY]"
          ></ion-input>
        </ion-item>
        <ion-item>
          Do limitu pozdního zrušení se započítávají pouze pracovní dny
          <ion-checkbox slot="end" [formControlName]="configKeys.STORNO_BEZ_LIMITU_O_VIKENDECH_A_SVATCICH"></ion-checkbox>
        </ion-item>
      </fieldset>
      <fieldset>
        <legend>
          <ion-label>Upravování proběhlých událostí</ion-label>
        </legend>
        <ion-item>
          Asistence: Počet dní, po které mohou koordinátoři provádět změny v proběhlé asistenci
          <ion-input
            slot="end"
            type="number"
            [formControlName]="configKeys.DOKDY_JE_MOZNA_EDITACE_PROBEHLYCH_ASISTENCI_DNY"
            [value]="configs[configKeys.DOKDY_JE_MOZNA_EDITACE_PROBEHLYCH_ASISTENCI_DNY]"
          ></ion-input>
        </ion-item>
      </fieldset>
      <fieldset>
        <legend>
          <ion-label>Přejezdy</ion-label>
        </legend>
        <ion-item>
          Výchozí doba přejezdu
          <ion-input
            slot="end"
            type="number"
            [formControlName]="configKeys.VYCHOZI_DOBA_PREJEZDU"
            [value]="configs[configKeys.VYCHOZI_DOBA_PREJEZDU]"
          ></ion-input>
          <div slot="end">minut</div>
        </ion-item>
      </fieldset>
    </div>
    <div *ngIf="selectedTab === ConfigTabType.PS.toString()">
      <!-- PS tab content -->
    </div>
  </form>
</ion-content>
